module.exports = __webpack_public_path__ + "static/media/allGreenLogo-alt.33c8f2b3.png";